import React from "react";
import { editorTypes } from "../../../../util/circleHelper";
import ProfileIconCard from "../../../../components/ProfileIconCard/ProfileIconCard";
import css from './CreatePostForm.module.css'

const EditorOptionDropdown = (props) => {
    const { toggleDropdown, toggleInlineStyle, toggleBlockType, currentBlockType, currentInlineStyle } = props
    const handleItemClick = (key) => {
        if (key === 'BOLD') {
            toggleInlineStyle(key)
        } else {
            toggleBlockType(key)
        }
        toggleDropdown()
    }
    
    const isItemActive = (key) => {
        if (key === 'BOLD') {
            return currentInlineStyle && currentInlineStyle.has(key);
        }
        return currentBlockType === key;
    }
    
    return <div>
        <ul>
            {editorTypes.map((item) => <li key={item.key} onClick={() => handleItemClick(item.key)}
                className={isItemActive(item.key) ? css.selectedItem : css.unselectedItem}>

                <ProfileIconCard type={item.key} />
                {item.label}</li>)}
        </ul>
    </div>;
};

export default EditorOptionDropdown;